<template>
  <div class="page_padding marginB">
    <div class="news-top"></div>
    <div class="title marginT">
      <span class="font30 fontBold">공지사항 글쓰기</span>
    </div>
    <editor></editor>
  </div>
</template>

<script>
import Editor from "@/components/editor/Editor.vue";
export default {
  components: {Editor},
  data() {
    return {
      isLogin: null,
    };
  },
  created() {
    this.isLogin = localStorage.loginUser === "springsoft";
  },
  watch: {
    isLogin(value) {
      if (!value) {
        alert("관리자 권한이 필요합니다.");
        this.$router.push("/news");
      }
    },
  },
};
</script>

<style scoped>
.title {
  padding-bottom: 30px;
  border-bottom: 2px solid black;
  margin-bottom: 40px;
}
</style>
